import { useState, useCallback, useEffect } from 'react';

interface IUseResize {
	windowWidth: number;
	isDesktop: boolean;
	isPhone: boolean;
}

export const useResize = (): IUseResize => {
	const [windowWidth, setWidth] = useState(window.innerWidth);

	const handleResize = useCallback((e: UIEvent) => {
		const window = e.target as Window;
		setWidth(window.innerWidth);
	}, []);

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return {
		windowWidth,
		isDesktop: windowWidth > 800,
		isPhone: windowWidth <= 800,
	};
};
